import { dashboard_bar_chart_palette } from './palettes.js';

export const createDictionaryOfColorsBoundToId = (ids) => {
  const idColorDictionary = {};
  ids.forEach((id, index) => {
    idColorDictionary[id] = dashboard_bar_chart_palette[index];   // add key to the object with the value of the id arguement, where the value of that key = value at index loop is on in dashboard_bar_chart_palette array of hex color codes
  });
  
  return idColorDictionary;
};
